import { useContext } from 'react';
import BugReportContext from './BugReportContext';

export const useBugReportContext = () => useContext(BugReportContext);
